// extracted by mini-css-extract-plugin
export default {"mbact":"Mbact_mbact__Ljz5K"};